import React from "react"
import { Image as ImageIcon } from "lucide-react"

const PhotoLinkButton = ({ label, count, onClick }) => {
  if (!count) return null

  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-1.5 text-xs text-[#5A6779] hover:text-[#FF6B3D]"
    >
      <ImageIcon size={13} />
      {label} ({count})
    </button>
  )
}

export default PhotoLinkButton
